import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SkeletonAnimation } from '../../skeleton-loader.types';

@Component({
  selector: 'cm-skeleton-form-flat',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-form-flat.component.html',
  styleUrl: './skeleton-form-flat.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonFormFlatComponent {
  public readonly animation = input<SkeletonAnimation>('shimmer');
}
